import * as React from "react";
import { ComponentTypes, DirectoryTreeType, IDirectoryLocation, Initiallocations } from "../../config/config";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../redux/index";
import { addWorkingDirectory, setOneDriveDetails, setWorkingDirectories } from "../../redux/modules/workingDirectory";
import { resetSavingLocation, setSavingLocation } from "../../redux/modules/savingLocation";
import { setMode } from "../../redux/modules/mode";
import { setLoading } from "../../redux/modules/loader";
import Loader from "../Loader";
import { IStoreItem } from "../../interfaces/IStoredItem";
import { IFilePanelInfo } from "../../interfaces/IFilePanelInfo";
import { IFolderPanelInfo } from "../../interfaces/IFolderPanelInfo";
import {
  initialFileOptionPanelInfoSetting,
  initialFolderOptionPanelInfoSetting,
  SharePointFolderContentTypeIds,
  validSaveModes,
} from "../../config/constants";
import {
  ActionButton,
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  IDialogContentProps,
  Label,
  PrimaryButton,
  Spinner,
  SpinnerSize
} from "@fluentui/react";
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import FileOptionPanel from "../panels/FileOptionPanel";
import FolderOptionPanel from "../panels/FolderOptionPanel";
import { ModeEnum } from "../enums/modeEnum";
import { IPageSettings } from "../../interfaces/IPageSettings";
import { FolderTypeIconQuery } from "../helpers/folderTypeIconQuery";
import { expanderConstants } from "../../redux/models/constants/expanders";
import ExpanderWithSubtitle from "./ExpanderWithSubtitle";
import { AccessLicenseHelper } from "../helpers/accessLicenseHelper";
import { setSearch } from "../../redux/modules/search";
import PinnedItems from "./home/PinnedItems";
import RecentItems from "./home/RecentItems";
import SharedItems from "./home/SharedItems";
import { setShowFolderDeleteDialog } from "../../redux/modules/showFolderDeleteDialogue";
import { isMobile } from "../../styles/mobileStyles"
import MyApprovals from "./myApprovals/MyApprovals";
import generalModule from "../../../../utilities/GeneralModule";
import { IOneDriveRootDetails } from "../../interfaces/IOneDriveRootDetails";
import { getHubSiteSites, getItemCustomSelect, getOneDriveRootDetails, getSharePointDocumentLibraries, getSharePointSiteFromDriveId, getSharePointSubsite } from "../../services/GraphService";
import { setContentManagerDirectory, setContentManagerExchange, setContentManagerSearchValue, setIsContentManagerContentLoading, toggleContentManagerReload } from "../../redux/modules/contentManagerDirectory";
import { ContentManagerDirectoryEnum } from "../enums/ContentManagerDirectoryEnum";
import { IAuthTokenResultDto } from "../../interfaces/IAuthTokenResultDto";
import { ContentManagerCopyMoveModeEnum } from "../enums/ContentManagerCopyMoveModeEnum";
import { getSites } from "../../redux/modules/sharepointInfo";
import { getChannels, getTeams } from "../../redux/modules/teams";
import { ISiteInfo, ISiteInfoLocation, mapSites } from "../../interfaces/ISiteInfo";
import authModule from "../../../../utilities/AuthModule";
import { IFolderLocation, ISharepointDocumentLocation } from "../../interfaces/ISharepointDocument";
import { ITeamChannelDto, ITeamChannelLocationDto } from "../../interfaces/services/ITeamChannelDto";
import { buildWorkingDirectoryFromTree, calculateLocationHeight, findWorkingDirectories, generateRandomString, openTreeFolderOptions } from "../helpers/treeHelperGeneral";
import { SharePointDocumentLibraryItem } from "../_v2/components/Explorer/FolderView/SharePointDocumentLibraryItem";
import { FolderViewWrapper } from "../helpers/folderViewWrapper";
import { getListSettings, getUserEffectivePermissions } from "../../services/SharePointRestServices";
import { setCanViewFolder } from "../../redux/modules/currentSharepointFolder";
import { logger } from "../../../../utilities/logger";
import savingLocationStructureModule from "../../../../utilities/SavingLocationStructureModule";
import { TeamChannelItem } from "../_v2/components/Explorer/FolderView/TeamChannelItem";
import { useLazyRenderListAsStreamTreeQuery } from "../_v2/redux/api/sharepoint/api-sharepoint-slice";
import { SharePointFolderItem } from "../_v2/components/Explorer/FolderView/SharePointFolderItem";
import treeStructureModule from "../../../../utilities/TreeStructureModule";
import { ITeam } from "../../interfaces/services/ITeam";
import { SiteItem } from "../_v2/components/Explorer/FolderView/SiteItem";
import { MainLocationItem } from "../_v2/components/Explorer/FolderView/MainLocationItem";
import { SharePointSiteHelper } from "../../../../utilities/SharePointSiteHelper";
import SuggestedItems from "./home/SuggestedItems";
import { ITessAccountLocation, ITessProject, ITessProjectFolderLocation, getTessAccountProjects, TessProjectStatuses, ITessProjectLocation, getStatusText } from "../../services/TessService";
import { TessAccountItem } from "../_v2/components/Explorer/FolderView/TessAccountItem";
import { TessProjectFolderItem } from "../_v2/components/Explorer/FolderView/TessProjectFolderItem";
import { ITessAuthHook } from "../../../../contentManager/Hooks/useTessPopUpAuth";
import { TessProjectTreeItem } from "../_v2/components/Explorer/FolderView/TessProjectTreeItem";
import { tryDecodeUriComponent } from "../../../../utilities/EncodeDecode";
import { FolderTypeEnum } from "../enums/FolderTypeEnum";

const mapStateToProps = (state: RootState) => {
  return {
    workingDirectories: state.workingDirectories?.workingDirectories,
    currentDirectory: state.workingDirectories?.workingDirectories?.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null,
    savingLocation: state.savingLocation,
    loading: state.loading.isLoading,
    mode: state.mode.mode,
    expanders: state.expanders,
    user: state.user,
    folderDeleteDialog: state.showFolderDeleteDialog,
    userSettings: state.user.settings,
    oneDriveRootDetails: state.workingDirectories.oneDriveRootDetails,
    isSideMenuCollapsed: generalModule.isInConentMangerMode() && state.contentManagerDirectory.isSideMenuCollapsed,
    nintexClientId: state.tenantInfo.nintexClientId,
    nintexClientSecret: state.tenantInfo.nintexClientSecret,
    moveTo: state.contentManagerDirectory.moveTo,
    enableExchange: state.tenantInfo.enableExchange,
    allowedSiteCollections: state.tenantInfo.allowedSiteCollections,
    allowedTeams: state.tenantInfo.allowedTeams,
    hideDocumentLibrariesInTeams: state.tenantInfo?.hideDocumentLibrariesInTeams,
    hideTeamsSitesInSharePoint: state.tenantInfo?.hideTeamsSitesInSharePoint,
    sites: state.sharePointInfo.sites,
    teams: state.teams.teams,
    hasFileSelected: state.files.files.some(file => file.isSelected),
    lastServerFetch_sites: state.sharePointInfo.lastServerFetch,
    lastServerFetch_teams: state.teams.lastServerFetch,
    isTessEnabled: state.tenantInfo?.isTessEnabled
  };
};

const mapDispatchToProps = {
  setWorkingDirectories,
  setOneDriveDetails,
  resetSavingLocation,
  setLoading,
  setMode,
  setSearch,
  setShowFolderDeleteDialog,
  setContentManagerDirectory,
  setIsContentManagerContentLoading,
  setContentManagerSearchValue,
  toggleContentManagerReload,
  setContentManagerExchange,
  getSites,
  getTeams,
  getChannels,
  setSavingLocation,
  addWorkingDirectory,
};

interface SiteChildren {
  channels: ITeamChannelLocationDto[];
  documents: ISharepointDocumentLocation[];
  subSites: ISiteInfoLocation[];
  subSitesNextHref: string;
}

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
interface LocationProps extends PropsFromRedux {
  hide: boolean;
  modeEnum?: ModeEnum;
  saveToOneDrive?: (
    folderName: string,
    fromLocationItemCurrentDirectory?: IPageSettings,
    savingLocationDirectory?: string,
    locationBeforeSaving?: IPageSettings[]
  ) => Promise<void>;
  requestFlowResourceToken?: (loginCallback: (authResult: IAuthTokenResultDto) => Promise<void>) => Promise<void>;
  tessAuthHook: ITessAuthHook;
}

const Location: React.FunctionComponent<LocationProps> = ({
  hide,
  workingDirectories,
  currentDirectory,
  setWorkingDirectories,
  setOneDriveDetails,
  setSearch,
  savingLocation,
  resetSavingLocation,
  loading,
  setLoading,
  modeEnum,
  saveToOneDrive,
  user,
  setShowFolderDeleteDialog,
  folderDeleteDialog,
  userSettings,
  oneDriveRootDetails,
  isSideMenuCollapsed,
  setContentManagerDirectory,
  setIsContentManagerContentLoading,
  setContentManagerSearchValue,
  toggleContentManagerReload,
  requestFlowResourceToken,
  nintexClientId,
  nintexClientSecret,
  setContentManagerExchange,
  moveTo,
  enableExchange,
  getChannels,
  sites,
  teams,
  mode,
  hasFileSelected,
  setSavingLocation,
  addWorkingDirectory,
  allowedSiteCollections,
  lastServerFetch_sites,
  lastServerFetch_teams,
  getSites,
  getTeams,
  hideDocumentLibrariesInTeams,
  hideTeamsSitesInSharePoint,
  isTessEnabled,
  tessAuthHook
}: LocationProps) => {
  const languageStrings = React.useContext(LanguageContext);

  const [isInContentManagerMode] = React.useState<boolean>(generalModule.isInConentMangerMode());
  const [isLicenseDialogHidden, setIsLicenseDialogHidden] = React.useState(true);
  const [isFileDeletionDialogHidden, setIsFileDeletionDialogHidden] = React.useState(true);
  const [fileOptionPanelInfo, setFileOptionPanelInfo] = React.useState<IFilePanelInfo>(initialFileOptionPanelInfoSetting);
  const [folderOptionPanelInfo, setFolderOptionPanelInfo] = React.useState<IFolderPanelInfo>(initialFolderOptionPanelInfoSetting);
  const [licenseMessageContent, setLicenseMessageContent] = React.useState<IDialogContentProps>(null);
  const [locations, setLocations] = React.useState<IDirectoryLocation[]>([]);
  const [locationItems, setLocationItems] = React.useState<JSX.Element[]>([]);
  const [locationItemsShort, setLocationItemsShort] = React.useState<JSX.Element[]>([]);
  const [locationHeight, setLocationHeight] = React.useState<number>(160);

  const selectedItem = React.useRef(null);
  const lastServerFetch_sites_ref = React.useRef<number>(new Date().getTime());
  const lastServerFetch_teams_ref = React.useRef<number>(new Date().getTime());
  // const loadTreeFromRedux = React.useRef(true);

  const [getListAsStreamTree] = useLazyRenderListAsStreamTreeQuery();

  const hideLicenseDialog = () => {
    setIsLicenseDialogHidden(true);
  }

  const showLicenseDialog = () => {
    setIsLicenseDialogHidden(false);
  }

  const hideFileDeleteDialog = () => {
    setIsFileDeletionDialogHidden(true);
  }

  const showFileDeleteDialog = () => {
    setIsFileDeletionDialogHidden(false);
  }

  React.useEffect(() => {
    setLocations(Initiallocations);
  }, []);

  React.useEffect(() => {
    const setupAsyncWrapper = async () => {
      setLoading(true);
      resetSavingLocation();
      setLoading(false);
    };

    setupAsyncWrapper();
  }, [savingLocation.display !== null]);

  const setUnableToAccessDialog = (locationType: string) => {
    const errorMessage = {
      type: DialogType.largeHeader,
      title: languageStrings.LicenseRequiredTitle,
      closeButtonAriaLabel: "Close",
      subText: languageStrings.LicenseRequired.replace("{placeholder}", locationType)
    };
    setLicenseMessageContent(errorMessage);
    showLicenseDialog();
  };

  const setContextAwareLoading = React.useCallback((isLoading: boolean, contentManagerOnly: boolean = false) => {
    if (!contentManagerOnly) {
      !isInContentManagerMode ? setLoading(isLoading) : setIsContentManagerContentLoading(isLoading);
    }
    else {
      setIsContentManagerContentLoading(isLoading);
    }
  }, []);

  React.useEffect(() => {
    // treeStructureModule.setLocations(locations);
    setLocationHeight(calculateLocationHeight(locations));
  }, [locations]);

  React.useEffect(() => {
    if (locations?.length > 0) {
      if (!isSideMenuCollapsed) {
        setLocationItems(renderLocations(locations));
      }
      else if (isSideMenuCollapsed) {
        setLocationItemsShort(renderLocations(locations));
      }
    }
  }, [locations, sites, teams, currentDirectory, isSideMenuCollapsed, moveTo.moveToEnabled, moveTo.mode]);

  React.useEffect(() => {
    //Adding server results if SharePoint is expanded
    if (locations?.length > 0) {
      const siteLocation = locations.find(x => x.type === ComponentTypes.SharePoint);
      if (siteLocation.expanded && !siteLocation.isServerRefreshed && lastServerFetch_sites && lastServerFetch_sites > lastServerFetch_sites_ref.current) {
        lastServerFetch_sites_ref.current = lastServerFetch_sites;
        onLocationChevronClicked(siteLocation, false, true);
      }
    }
  }, [locations, lastServerFetch_sites]);

  React.useEffect(() => {
    //Adding server results if Teams are expanded
    if (locations?.length > 0) {
      const teamLocation = locations.find(x => x.type === ComponentTypes.Teams);
      if (teamLocation.expanded && !teamLocation.isServerRefreshed && lastServerFetch_teams && lastServerFetch_teams > lastServerFetch_teams_ref.current) {
        lastServerFetch_teams_ref.current = lastServerFetch_teams;
        onLocationChevronClicked(teamLocation, false, true);
      }
    }
  }, [locations, lastServerFetch_teams]);

  React.useEffect(() => {
    if (isTessEnabled && tessAuthHook?.isTessTokenAvailable && locations?.length > 0) {
      const tessLocation = locations.find(x => x.type === ComponentTypes.Tess);
      if (tessLocation) {
        onLocationChevronClicked(tessLocation, true);
      }
    }
  }, [isTessEnabled, tessAuthHook]);

  const checkPreExpandTeamId = React.useRef<boolean>(isInContentManagerMode);
  React.useEffect(() => {
    if (checkPreExpandTeamId.current
      && locations?.length > 0
      && workingDirectories?.length > 1) {
      const teamLocation = locations.find(x => x.type === ComponentTypes.Teams);
      if (teamLocation) {
        const teamIdToPreExpand: string | null = generalModule.getPreExpandTeamId();
        if (teamIdToPreExpand) {
          const dirTeamId: string = workingDirectories.find(dir => dir.teamGroupId && dir.teamGroupId === teamIdToPreExpand)?.teamGroupId;
          if (dirTeamId) {
            onLocationChevronClicked(teamLocation, false, true, dirTeamId);
            generalModule.setPreExpandTeamId(null);
            checkPreExpandTeamId.current = false;
          }
        }
      }
    }
  }, [locations, workingDirectories]);

  const isValidDropZone = React.useMemo((): boolean => {
    return isInContentManagerMode || validSaveModes.some(item => item === mode);
  }, [mode]);

  const getTreeLocations = React.useCallback((): any[] => {
    return locations;
  }, [locations]);

  const handleSaveClick = React.useCallback(async (item, e) => {
    e.preventDefault();
    e.stopPropagation();
    e.persist();

    setContextAwareLoading(true);

    try {
      const newWorkingDirectories = findWorkingDirectories(locations, item);
      const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
      const currentDir = directories[directories.length - 1];
      const parent = newWorkingDirectories.find(x => x.id === item.parentId);

      var folderViewWrapper = new FolderViewWrapper(parent.subSites, { ...currentDir, DocumentLibrary: item.name, sharePointListId: item.sharePointListId });
      const canViewFolder = folderViewWrapper.canViewFolder();
      const accessToken = await authModule.getSharePointAccessToken();
      const webUrl = currentDir?.webUrl;
      const [settings, permissions] = await Promise.all([
        getListSettings(accessToken, webUrl, item.sharePointListId),
        getUserEffectivePermissions(accessToken, webUrl, item.sharePointListId)
      ]);

      setCanViewFolder({
        sharepointListId: item.sharePointListId,
        canView: canViewFolder,
        canCreateFolder: canViewFolder ? settings?.EnableFolderCreation : false,
        contentTypesEnabled: settings?.ContentTypesEnabled,
        enableMinorVersions: settings?.EnableMinorVersions,
        disableOpenInApp: settings?.ExcludeFromOfflineClient === true,
        userPermissions: permissions
      });

      savingLocationStructureModule.setSavingLocationStructure(directories);

      if (isInContentManagerMode) {
        generalModule.setOpenPanelUploadPanel(true);
        setWorkingDirectories(directories);
        setContentManagerSearchValue("");
        toggleContentManagerReload();
      } else {
        const savingDirectory = {
          ...directories[directories.length - 1],
          isSaveLocationStructureSet: true,
          displayName: languageStrings.Properties,
          type: ComponentTypes.Saving
        }

        const newLocations = [
          ...directories,
          savingDirectory,
        ];

        setWorkingDirectories(newLocations);
      }
    } catch (error) {
      logger(error, "Locations.tsx (handleSaveClick)");
    }

    setSearch("");
    setContextAwareLoading(false);
  }, [locations, user]);

  const onChannelSaveClicked = React.useCallback(async (event: React.SyntheticEvent, item: ITeamChannelLocationDto, isSaveRequest: boolean = false) => {
    if (isSaveRequest) {
      event.preventDefault();
      event.stopPropagation();

      setContextAwareLoading(true);

      try {
        const newWorkingDirectories = findWorkingDirectories(locations, item);
        const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);

        savingLocationStructureModule.setSavingLocationStructure(directories);

        if (isInContentManagerMode) {
          generalModule.setOpenPanelUploadPanel(true);
          setWorkingDirectories(directories);
        } else {
          const savingDirectory = {
            ...directories[directories.length - 1],
            isSaveLocationStructureSet: true,
            displayName: languageStrings.Properties,
            type: ComponentTypes.Saving
          }

          const newLocations = [
            ...directories,
            savingDirectory,
          ];

          setWorkingDirectories(newLocations);
        }

      } catch (error) {
        logger(error, "Locations.tsx (onChannelSaveClicked)");
      }

      setContextAwareLoading(false);
    }
  }, [locations, user]);

  const onTreeItemClick = React.useCallback(async (event: React.SyntheticEvent, treeItem: any) => {
    event.stopPropagation();
    setContextAwareLoading(true);
    try {
      setLocationItem(treeItem, true, undefined);
      const newWorkingDirectories = findWorkingDirectories(locations, treeItem);
      const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
      setWorkingDirectories(directories);
      if (isInContentManagerMode) {
        setContentManagerSearchValue("");
        toggleContentManagerReload();
      }
    } catch (error) {
      logger(error, "Locations.tsx (onTreeItemClick)");
    }
    setContextAwareLoading(false);
  }, [locations, user]);

  const renderLocations = (locations: IDirectoryLocation[]) => {
    return locations.map((locationItem, index) => {
      if (locationItem.type === ComponentTypes.OneDrive && (!user.oneDriveWebUrl || 0 === user.oneDriveWebUrl.length || !userSettings.enableOneDrive)) {
        return null;
      }

      if (locationItem.type === ComponentTypes.SharePoint && (!userSettings.enableSharePoint)) {
        return null;
      }

      if (locationItem.type === ComponentTypes.Teams && (!userSettings.enableTeams)) {
        return null;
      }

      if (locationItem.type === ComponentTypes.Exchange && (!isInContentManagerMode || !enableExchange)) {
        return null;
      }

      if (locationItem.type === ComponentTypes.Exchange && moveTo.moveToEnabled && (moveTo.mode === ContentManagerCopyMoveModeEnum.CopySelectedEmails || moveTo.mode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails)) {
        return null;
      }

      if (locationItem.type === ComponentTypes.Tess && !isTessEnabled) {
        return null;
      }

      return (
        <div key={`${locationItem.id}-${index}`}>
          <MainLocationItem
            item={locationItem}
            isMobile={isMobile()}
            setContextAwareLoading={setContextAwareLoading}
            onRefreshClick={locationItem.type === ComponentTypes.Tess && (async () => tessAuthHook?.loadTessAccounts(true))}
            isSideMenuCollapsed={isSideMenuCollapsed}
            onMainLocationClick={async () => {
              try {
                if (!(moveTo.moveToEnabled && (moveTo.mode === ContentManagerCopyMoveModeEnum.CopySelectedEmails || moveTo.mode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails))) {
                  setContentManagerExchange({ selectedFolderId: "", selectedFolderName: "", selectedAccount: "" })
                }

                if (locationItem.type === ComponentTypes.Tess && !tessAuthHook?.isTessTokenAvailable) {
                  onLocationChevronClicked(locationItem);
                  return;
                }

                if (!AccessLicenseHelper.canAccessItem(user.licenseType, locationItem.type) || !AccessLicenseHelper.isLocationEnabled(locationItem.type, user.settings)) {
                  setUnableToAccessDialog(locationItem.type);
                  return;
                }

                let oneDriveDetails: IOneDriveRootDetails;
                if (locationItem.type === ComponentTypes.OneDrive) {
                  if (oneDriveRootDetails) {
                    oneDriveDetails = oneDriveRootDetails;
                  }
                  else {
                    setContextAwareLoading(true);
                    try {
                      oneDriveDetails = await getOneDriveRootDetails();
                      setOneDriveDetails(oneDriveDetails);
                    } catch (err) {
                      logger(err, "Locations.tsx (onMainLocationClick)");
                    }
                    setContextAwareLoading(false);
                  }
                  if (isInContentManagerMode) {
                    setContentManagerSearchValue("");
                    if (currentDirectory?.type == ComponentTypes.OneDriveSubFolder || (currentDirectory?.type == ComponentTypes.OneDrive && currentDirectory.directory?.length > 0)) {
                      toggleContentManagerReload();
                    }
                  };
                }
                else if (isInContentManagerMode) {
                  if (locationItem.type === ComponentTypes.SharePoint) setContentManagerDirectory(ContentManagerDirectoryEnum.SharePoint);
                  if (locationItem.type === ComponentTypes.Teams) setContentManagerDirectory(ContentManagerDirectoryEnum.Teams);
                  if (locationItem.type === ComponentTypes.Exchange) setContentManagerDirectory(ContentManagerDirectoryEnum.Exchange);
                  if (locationItem.type === ComponentTypes.Tess) setContentManagerDirectory(ContentManagerDirectoryEnum.Tess);
                  return;
                }

                const directories: IPageSettings[] = [{
                  type: locationItem.type,
                  id: locationItem.id,
                  directory: "",
                  displayName: locationItem.name,
                  webUrl: locationItem.type === ComponentTypes.OneDrive ? user.oneDriveWebUrl : "",
                  sharePointListId: oneDriveDetails?.sharePointListId
                }];

                if (locationItem.type === ComponentTypes.OneDrive) {
                  directories[0].fileTitle = locationItem.name;
                }

                setWorkingDirectories(directories);

                setSearch("");
              } catch (error) {
                logger(error, "Locations.tsx (onMainLocationClick)");
              }
            }}
            onExpandCollapseClick={onLocationChevronClicked}
          />
          {!isSideMenuCollapsed && locationItem.sites && locationItem.expanded && renderLocationSites(locationItem.sites, locationItem.type === ComponentTypes.Teams)}
          {!isSideMenuCollapsed && locationItem.accounts && locationItem.expanded && renderLocationTessAccount(locationItem.accounts)}
          {!isSideMenuCollapsed && locationItem.folders && locationItem.expanded && renderFolders(locationItem.folders, location)}
          {!isSideMenuCollapsed && locationItem.expanded && locationItem.actions?.length > 0 && locationItem.actions}
          {!isSideMenuCollapsed && locationItem.expanded && locationItem.message && locationItem.message}
        </div>
      )
    });
  };

  const renderLocationSites = (locationSites: ISiteInfoLocation[], isMainTeamsLocation: boolean = false) => {
    return SharePointSiteHelper.groupAndSortSites(locationSites)
      .map((location, index) => {
        // return location.isTeam && !userSettings.enableTeams ? null : (
        return (isMainTeamsLocation || !location.isTeam || !(hideTeamsSitesInSharePoint || !userSettings.enableTeams)) && (
          <div key={`${location.id}-${index}`}>
            <SiteItem
              item={location}
              isTeamsLocation={isMainTeamsLocation}
              isMobile={isMobile()}
              allowScroll
              onSiteClick={async (site: ISiteInfoLocation) => {
                setLocationItem(site, true, undefined);
                const newWorkingDirectories = findWorkingDirectories(locations, site);
                const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
                setWorkingDirectories(directories);
              }}
              onExpandCollapseClick={onLocationSitesChevronClicked}
              onOptionsClick={async (site: ISiteInfoLocation) => setFolderOptionPanelInfo(await openTreeFolderOptions(locations, site, user))}
            />
            {location.subSites && location.expanded && renderLocationSites(location.subSites)}

            {location.subSitesNextHref && <div style={{ paddingLeft: (location.level ? location.level + 1 : 1) * 20 }}>
              {!location.isLoading && <ActionButton iconProps={{ iconName: "Table" }} allowDisabledFocus onClick={async (e: any) => {
                e.stopPropagation();
                setLocationItem(location, undefined, true);

                try {
                  const level = location.level ? location.level : 0;

                  let accessToken = await authModule.getGraphAccessToken();
                  let subSiteResult = await getSharePointSubsite(accessToken, location.id, allowedSiteCollections, location.subSitesNextHref);

                  const subsites: ISiteInfoLocation[] = subSiteResult?.data?.map(subsite => {
                    return {
                      id: subsite.id,
                      name: subsite.displayName,
                      description: subsite.description,
                      webUrl: subsite.webUrl,
                      isSubsite: true,
                      canExpand: true,
                      expanded: false,
                      parentId: location.id,
                      treeType: DirectoryTreeType.site,
                      level: level + 1,
                      isLoading: false,
                      loaded: false,
                      isSelected: false,
                      randomId: generateRandomString()
                    }
                  })

                  setLocationsSiteSubsiteUpdate(location, [...location.subSites, ...subsites], location.documents, undefined, undefined, true, false, subSiteResult.nextPageLink);

                } catch (error) {
                  logger(error, "Locations.tsx (subsites load more (getSharePointSubsite))");
                  setLocationItem(location, undefined, false);
                }
              }}>
                {languageStrings.LoadMore}
              </ActionButton>}

            </div>}
            {location.subSitesNextHref && location.isLoading && <div style={{ paddingTop: "10px" }}>
              <Spinner size={SpinnerSize.small} />
            </div>}

            {location.channels && location.expanded && renderChannels(location.channels)}
            {location.documents && location.expanded && renderDocuments(location.documents)}

          </div>
        )
      });
  };

  const renderDocuments = (documents: ISharepointDocumentLocation[]) => {
    return documents.map((document, index) => (
      <div key={`${document.id}-${index}`}>
        <SharePointDocumentLibraryItem
          key={index}
          treeItem={document}
          isMobile={isMobile()}
          isValidDropZone={isValidDropZone && !document.isList}
          allowScroll
          getTreeLocations={getTreeLocations}
          onTreeItemClick={onTreeItemClick}
          hasFileSelected={hasFileSelected}
          handleSaveClick={handleSaveClick}
          openFolderOptionsTree={async (e) => {
            e.stopPropagation();
            setFolderOptionPanelInfo(await openTreeFolderOptions(locations, document, user));
          }}
          onTreeExpand={async (isRefresh) => {
            // if (isRefresh || (!document.expanded && (!document.folders || document.folders?.length === 0))) {
            if (isRefresh || (!document.expanded && !document.loaded)) {
              setLocationItem(document, undefined, true);
              try {
                const newWorkingDirectories = findWorkingDirectories(locations, document);
                const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
                const currDirectory = directories[directories.length - 1];

                const level = document.level;
                let folders: IFolderLocation[] = [];

                const siteUrl: string = currDirectory.webUrl || document.siteUrl;
                const sharePointListId: string = currDirectory.sharePointListId || document.sharePointListId;

                const results = await getListAsStreamTree({
                  siteUrl,
                  sharePointListId,
                  accessToken: await authModule.getSharePointAccessToken(),
                  nextPageUrl: "",
                  serverRelativePath: ""
                });

                const foldersNextHref = results?.data?.ListData?.NextHref ? results?.data?.ListData?.NextHref : "";

                if (results?.data?.ListData?.Row && results?.data?.ListData?.Row.length > 0) {
                  folders = results?.data?.ListData?.Row.map(row => {
                    const folderChildCount = row.FolderChildCount ? +row.FolderChildCount : 0;

                    const spItemUrlparts = row['.spItemUrl'].split('/');
                    const itemId = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
                    const driveId = spItemUrlparts[spItemUrlparts.length - 3];

                    return {
                      id: itemId,
                      name: row.FileLeafRef,
                      level: level + 1,
                      driveId,
                      sharePointUniqueId: row.UniqueId.replace("{", "").replace("}", ""),
                      contentTypeId: row.ContentTypeId,
                      path: row.FileRef,
                      canExpand: folderChildCount > 0,
                      expanded: false,
                      isLoading: false,
                      webUrl: siteUrl,
                      sharePointListId,
                      treeType: DirectoryTreeType.folder,
                      randomId: generateRandomString(),
                      canRefresh: true
                    }
                  })
                }

                setLocationsSiteSubsiteUpdate(document, undefined, undefined, folders, foldersNextHref, false, isRefresh, undefined);

              } catch (error) {
                logger(error, "Locations.tsx (renderDocuments(getListAsStreamTree))");
              }
              setLocationItem(document, undefined, false);
            }
            else if ((!document.expanded && document.folders?.length > 0) || document.expanded) {
              setLocationsToggleExpanded(document);
            }

          }}
        />
        {document.folders && document.expanded && renderFolders(document.folders, document)}
      </div>
    ));
  };

  const renderChannels = (channels: ITeamChannelLocationDto[]) => {
    return channels.map((channel, index) => (
      <div key={`${channel.id}-${index}`}>
        <TeamChannelItem
          key={index}
          treeItem={channel}
          isMobile={isMobile()}
          isValidDropZone={isValidDropZone}
          hasFileSelected={hasFileSelected}
          allowScroll
          getTreeLocations={getTreeLocations}
          onChannelClicked={onChannelSaveClicked}
          onTreeItemClick={onTreeItemClick}
          inLocationsComponent={true}
          openFolderOptionsTree={async (e) => {
            e.stopPropagation();
            setLocationItem(channel, undefined, undefined, true);
            setFolderOptionPanelInfo(await openTreeFolderOptions(locations, channel, user));
            setLocationItem(channel, undefined, undefined, false);
          }}
          onTreeExpand={async (isRefresh) => {
            // if (isRefresh || (!channel.expanded && (!channel.folders || channel.folders?.length === 0))) {
            if (isRefresh || (!channel.expanded && !channel.loaded)) {
              setLocationItem(channel, undefined, true);
              try {
                const newWorkingDirectories = findWorkingDirectories(locations, channel);
                const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
                const currDirectory = directories[directories.length - 1];

                const domain = new URL(currDirectory.webUrl).origin;

                const level = channel.level;
                let folders: IFolderLocation[] = [];

                const results = await getListAsStreamTree({
                  siteUrl: currDirectory.webUrl,
                  sharePointListId: currDirectory.sharePointListId,
                  accessToken: await authModule.getSharePointAccessToken(),
                  nextPageUrl: "",
                  serverRelativePath: currDirectory.directory ? `${currDirectory.webUrl.replace(domain, "")}/${currDirectory.directory}` : ""
                });

                const foldersNextHref = results?.data?.ListData?.NextHref ? results?.data?.ListData?.NextHref : "";

                if (results?.data?.ListData?.Row && results?.data?.ListData?.Row.length > 0) {
                  folders = results?.data?.ListData?.Row.map(row => {
                    const folderChildCount = row.FolderChildCount ? +row.FolderChildCount : 0;

                    const spItemUrlparts = row['.spItemUrl'].split('/');
                    const itemId = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
                    const driveId = spItemUrlparts[spItemUrlparts.length - 3];

                    return {
                      id: itemId,
                      name: row.FileLeafRef,
                      level: level + 1,
                      driveId,
                      sharePointUniqueId: row.UniqueId.replace("{", "").replace("}", ""),
                      contentTypeId: row.ContentTypeId,
                      path: row.FileRef,
                      canExpand: folderChildCount > 0,
                      expanded: false,
                      isLoading: false,
                      webUrl: currDirectory.webUrl,
                      sharePointListId: currDirectory.sharePointListId,
                      treeType: DirectoryTreeType.folder,
                      randomId: generateRandomString(),
                      canRefresh: true
                    }
                  })
                }

                setLocationsSiteSubsiteUpdate(channel, undefined, undefined, folders, foldersNextHref, false, isRefresh, undefined);

              } catch (error) {
                logger(error, "Locations.tsx (renderChannels(getListAsStreamTree))");
              }
              setLocationItem(channel, undefined, false);
            }
            else if ((!channel.expanded && channel.folders?.length > 0) || channel.expanded) {
              setLocationsToggleExpanded(channel);
            }

          }}
        />
        {channel.folders && channel.expanded && renderFolders(channel.folders, channel)}
      </div>
    ));
  };

  const renderFolders = (folders: IFolderLocation[], location: any) => {
    return (
      <div>
        {folders.map((folder, index) => (
          <div key={`${folder.id}-${index}`}>
            <SharePointFolderItem
              key={index}
              treeItem={folder}
              isMobile={isMobile()}
              hasFileSelected={hasFileSelected}
              isValidDropZone={isValidDropZone}
              allowScroll
              getTreeLocations={getTreeLocations}
              onTreeItemClick={onTreeItemClick}
              onSaveClicked={onFolderSaveClicked}
              openFolderOptionsTree={async (e) => {
                e.stopPropagation();
                setLocationItem(folder, undefined, undefined, true);
                setFolderOptionPanelInfo(await openTreeFolderOptions(locations, folder, user));
                setLocationItem(folder, undefined, undefined, false);
              }}
              onTreeExpand={async (isRefresh) => {
                // if (isRefresh || (!folder.expanded && (!folder.folders || folder.folders?.length === 0))) {
                if (isRefresh || (!folder.expanded && !folder.loaded)) {
                  setLocationItem(folder, undefined, true);
                  try {
                    const newWorkingDirectories = findWorkingDirectories(locations, folder);
                    const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
                    const currDirectory = directories[directories.length - 1];

                    const level = folder.level;
                    let subFolders: IFolderLocation[] = [];

                    const results = await getListAsStreamTree({
                      siteUrl: folder.isOneDrive ? oneDriveRootDetails.sharePointSiteUrl : folder.webUrl,
                      sharePointListId: folder.sharePointListId,
                      accessToken: folder.isOneDrive ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                      nextPageUrl: "",
                      serverRelativePath: folder.path
                    });

                    const foldersNextHref = results?.data?.ListData?.NextHref ? results?.data?.ListData?.NextHref : "";

                    if (results?.data?.ListData?.Row && results?.data?.ListData?.Row.length > 0) {
                      subFolders = results?.data?.ListData?.Row.map(row => {
                        const folderChildCount = row.FolderChildCount ? +row.FolderChildCount : 0;

                        const spItemUrlparts = row['.spItemUrl'].split('/');
                        const itemId = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
                        const driveId = spItemUrlparts[spItemUrlparts.length - 3];

                        return {
                          id: itemId,
                          name: row.FileLeafRef,
                          level: level + 1,
                          driveId,
                          sharePointUniqueId: row.UniqueId.replace("{", "").replace("}", ""),
                          contentTypeId: row.ContentTypeId,
                          path: row.FileRef,
                          canExpand: folderChildCount > 0,
                          expanded: false,
                          isLoading: false,
                          webUrl: currDirectory.webUrl,
                          sharePointListId: currDirectory.sharePointListId ?? folder.sharePointListId,
                          treeType: DirectoryTreeType.folder,
                          isOneDrive: folder.isOneDrive,
                          randomId: generateRandomString(),
                          canRefresh: true
                        }
                      })
                    }

                    setLocationsSiteSubsiteUpdate(folder, undefined, undefined, subFolders, foldersNextHref, false, isRefresh, undefined);

                  } catch (error) {
                    logger(error, "Locations.tsx (renderFolders(getListAsStreamTree))");
                    setLocationItem(folder, undefined, false);
                  }
                }
                else if ((!folder.expanded && folder.folders?.length > 0) || folder.expanded) {
                  setLocationsToggleExpanded(folder);
                }
              }}
            />
            {index === folders.length - 1 && location.foldersNextHref && <div style={{ paddingLeft: (location.level ? location.level + 1 : 1) * 15 + 20 }}>
              {!location.isLoading && <ActionButton iconProps={{ iconName: "Table" }} allowDisabledFocus onClick={async (e: any) => {
                e.stopPropagation();
                setLocationItem(location, undefined, true);
                const newWorkingDirectories = findWorkingDirectories(locations, location);
                const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
                const currDirectory = directories[directories.length - 1];

                try {
                  const level = location.level ? location.level : 0;
                  let folders: IFolderLocation[] = [];

                  const inOneDrive = location.isOneDrive || location.type === ComponentTypes.OneDrive;
                  const webUrl = inOneDrive ? oneDriveRootDetails.sharePointSiteUrl : currDirectory.webUrl;
                  const sharePointListId = inOneDrive ? oneDriveRootDetails.sharePointListId : currDirectory.sharePointListId;

                  const results = await getListAsStreamTree({
                    siteUrl: webUrl,
                    sharePointListId,
                    accessToken: inOneDrive ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                    nextPageUrl: location.foldersNextHref,
                    serverRelativePath: currDirectory.serverRelativePath
                  });

                  const foldersNextHref = results?.data?.ListData?.NextHref ? results?.data?.ListData?.NextHref : "";

                  if (results?.data?.ListData?.Row && results?.data?.ListData?.Row.length > 0) {
                    folders = results?.data?.ListData?.Row.map(row => {
                      const spItemUrlparts = row['.spItemUrl'].split('/');
                      const itemId = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
                      const driveId = spItemUrlparts[spItemUrlparts.length - 3];

                      return {
                        id: itemId,
                        name: row.FileLeafRef,
                        level: level + 1,
                        driveId,
                        sharePointUniqueId: row.UniqueId.replace("{", "").replace("}", ""),
                        contentTypeId: row.ContentTypeId,
                        path: row.FileRef,
                        canExpand: true,
                        expanded: false,
                        isLoading: false,
                        webUrl,
                        sharePointListId,
                        isOneDrive: inOneDrive,
                        treeType: DirectoryTreeType.folder,
                        randomId: generateRandomString(),
                        canRefresh: true
                      }
                    })
                  }

                  setLocationsSiteSubsiteUpdate(location, undefined, undefined, [...location.folders, ...folders], foldersNextHref, true, false, undefined);

                } catch (error) {
                  logger(error, "Locations.tsx (renderChannels(getListAsStreamTree))");
                  setLocationItem(location, undefined, false);
                }
              }}>
                {languageStrings.LoadMore}
              </ActionButton>}

            </div>}
            {index === folders.length - 1 && location.foldersNextHref && location.isLoading && <div style={{ paddingTop: "10px" }}>
              <Spinner size={SpinnerSize.small} />
            </div>}
            {folder.folders && folder.expanded && renderFolders(folder.folders, folder)}
          </div>
        ))}

      </div>)
  };

  const renderLocationTessAccount = (locationAccounts: ITessAccountLocation[]) => {
    return locationAccounts.map((location, index) => {
      return <div key={`${location.id}-${index}`}>
        <TessAccountItem
          item={location}
          isMobile={isMobile()}
          allowScroll
          onSiteClick={async (account: ITessAccountLocation) => {
            setLocationItem(account, true, undefined);
            const newWorkingDirectories = findWorkingDirectories(locations, account);
            const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
            setWorkingDirectories(directories);
          }}
          onExpandCollapseClick={onLocationTessAccountChevronClicked}
          onOptionsClick={async (account: ITessAccountLocation) => setFolderOptionPanelInfo(await openTreeFolderOptions(locations, account, user))}
        />
        {location.documents && location.expanded && renderDocuments(location.documents)}
        {location.folders && location.expanded && renderFolders(location.folders, location)}
        {location.projectFolders && location.expanded && renderLocationTessProjectFolders(location.projectFolders)}
      </div>
    });
  };

  const renderLocationTessProjectFolders = (projectFolderLocations: ITessProjectFolderLocation[]) => {
    return projectFolderLocations.map((location, index) => {
      return <div key={`${location.name}-${index}`}>
        <TessProjectFolderItem
          item={location}
          isMobile={isMobile()}
          allowScroll
          onProjectFolderClick={async (projectFolder: ITessProjectFolderLocation) => {
            onLocationTessProjectFolderChevronClicked(projectFolder);
          }}
          onExpandCollapseClick={onLocationTessProjectFolderChevronClicked}
        />
        {location.projects && location.expanded && renderLocationTessProjects(location.projects)}
      </div>
    });
  };

  const renderLocationTessProjects = (projectLocations: ITessProjectLocation[]) => {
    return projectLocations.map((location, index) => {
      return <div key={`${location.name}-${index}`}>
        <TessProjectTreeItem
          item={location}
          isMobile={isMobile()}
          allowScroll
          onProjectClick={async (project: ITessProjectLocation) => {
            setLocationItem(project, true, undefined);
            const newWorkingDirectories = findWorkingDirectories(locations, project);
            const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
            setWorkingDirectories(directories);
          }}
          onOptionsClick={async (project: ITessProjectLocation) => setFolderOptionPanelInfo(await openTreeFolderOptions(locations, project, user))}
          onExpandCollapseClick={onLocationTessProjectChevronClicked}
        />
        {location.documents && location.expanded && renderDocuments(location.documents)}
        {location.folders && location.expanded && renderFolders(location.folders, location)}
      </div>
    });
  };

  const onLocationChevronClicked = async (location: IDirectoryLocation, isRefresh: boolean = false, isServerRefresh: boolean = false, preExpandTeamId: string = null) => {
    if (location.type === ComponentTypes.OneDrive) {
      // if (isRefresh || (!location.expanded && (!location.folders || location.folders?.length === 0))) {
      if (isRefresh || (!location.expanded && !location.loaded)) {
        let folders: IFolderLocation[] = [];

        try {
          setLocationItem(location, undefined, true);

          let oneDriveDetails: IOneDriveRootDetails;
          if (!oneDriveRootDetails) {
            oneDriveDetails = await getOneDriveRootDetails();
            setOneDriveDetails(oneDriveDetails);
          }

          const results = await getListAsStreamTree({
            siteUrl: (oneDriveRootDetails || oneDriveDetails).sharePointSiteUrl,
            sharePointListId: (oneDriveRootDetails || oneDriveDetails).sharePointListId,
            accessToken: await authModule.getOneDriveAccessToken(),
            nextPageUrl: "",
            serverRelativePath: ""
          });

          const foldersNextHref = results?.data?.ListData?.NextHref ? results.data.ListData.NextHref : "";

          if (results?.data?.ListData?.Row && results.data.ListData.Row.length > 0) {
            folders = results.data.ListData.Row.map(row => {
              const folderChildCount = row.FolderChildCount ? +row.FolderChildCount : 0;

              const spItemUrlparts = row['.spItemUrl']?.split('/');
              if (Array.isArray(spItemUrlparts) && spItemUrlparts.length > 2) {
                const itemId = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
                const driveId = spItemUrlparts[spItemUrlparts.length - 3];

                const sharePointListId = results.data.listName?.replace("{", "").replace("}", "");
                return {
                  id: itemId,
                  name: row.FileLeafRef,
                  level: 2,
                  parentId: driveId,
                  sharePointUniqueId: row.UniqueId.replace("{", "").replace("}", ""),
                  contentTypeId: row.ContentTypeId,
                  path: row.FileRef,
                  canExpand: folderChildCount > 0,
                  expanded: false,
                  isLoading: false,
                  webUrl: user.oneDriveWebUrl,
                  sharePointListId,
                  treeType: DirectoryTreeType.folder,
                  isOneDrive: true,
                  randomId: generateRandomString()
                }
              }
              return null;
            })
              .filter(folder => folder);
          }

          setLocations(prevLocations => {
            return prevLocations.map(prevLocation => {
              if (prevLocation.id === location.id) {
                return {
                  ...prevLocation,
                  folders: [...folders],
                  foldersNextHref,
                  expanded: isRefresh ? location.expanded : !location.expanded,
                  canExpand: folders?.length > 0,
                  isLoading: false,
                  loaded: true
                };
              } else {
                return prevLocation;
              }
            });
          });

        } catch (error) {
          logger(error, "Locations.tsx: onLocationChevronClicked (OneDrive)");
          setLocationItem(location, undefined, false);
        }
      }
      else if ((!location.expanded && location.folders?.length > 0) || location.expanded) {
        setLocationsToggleExpanded(location);
      }
    }
    else if (location.type === ComponentTypes.Tess) {
      if (tessAuthHook?.isTessTokenAvailable && (isServerRefresh || isRefresh || (!location.expanded && !location.loaded))) {
        try {
          const accountSites = tessAuthHook?.tessAccountSites?.map(accountSite => {
            const randomString: string = generateRandomString();
            return {
              ...accountSite,
              accountId: accountSite.accountId,
              isSubsite: false,
              key: randomString,
              randomId: randomString,
              canExpand: true,
              expanded: false,
              parentId: location.id,
              treeType: DirectoryTreeType.tessAccount,
              level: 2,
              isLoading: false,
              loaded: false,
              isSelected: false
            };
          });

          setLocations(prevLocations => {
            return prevLocations.map(prevLocation => {
              if (prevLocation.id === location.id) {
                return {
                  ...prevLocation,
                  accounts: accountSites?.sort(SharePointSiteHelper.sortSites) ?? [],
                  actions: [],
                  expanded: (isServerRefresh || isRefresh) ? location.expanded : !location.expanded,
                  canExpand: true,
                  message: !(accountSites?.length > 0) && <div key="ac_no_data" style={{ textAlign: "center" }}>
                    <Label>
                      {languageStrings.GenericNoResultsFoundText}
                    </Label>
                  </div>,
                  isLoading: tessAuthHook?.isTessRequestInProgress,
                  loaded: true,
                  isServerRefresh
                };
              } else {
                return prevLocation;
              }
            });
          });
        } catch (error) {
          logger(error, "Locations.tsx: onLocationChevronClicked (Tess)");
          setLocationItem(location, undefined, false);
        }
      }
      else if ((!location.expanded && (location.accounts?.length > 0 || location.message || !tessAuthHook?.isTessTokenAvailable)) || location.expanded) {
        setLocations(prevLocations => {
          return prevLocations.map(prevLocation => {
            if (prevLocation.id === location.id) {
              return {
                ...prevLocation,
                expanded: !location.expanded,
                isLoading: tessAuthHook?.isTessRequestInProgress || prevLocation.isLoading,
                actions: !tessAuthHook?.isTessRequestInProgress && !tessAuthHook?.isTessTokenAvailable
                  ? [<div key={`ac_token_required`} style={{ textAlign: "center", paddingTop: "5px" }}>
                    <DefaultButton
                      text={languageStrings.RequestAccess}
                      onClick={() => {
                        tessAuthHook?.requestTessToken();
                      }} />
                  </div>]
                  : []
              };
            } else {
              return prevLocation;
            }
          });
        });
      }
    }
    else {
      // if (isRefresh || (!location.expanded && location.sites?.length === 0)) {
      if (isServerRefresh || isRefresh || (!location.expanded && !location.loaded)) {
        try {
          setLocationItem(location, undefined, true);

          let combinedSites: ISiteInfoLocation[] = [];
          let localTeams: ITeam[] = teams ? [...teams] : [];

          if (isRefresh) {
            const [updatedSites, updatedTeams] = await Promise.all([await getSites(allowedSiteCollections, null, true, false), await getTeams(true, false)]);

            combinedSites = location.type === ComponentTypes.SharePoint ? updatedSites ? [...updatedSites.map((site, index) => ({ ...site, key: "s" + index, randomId: generateRandomString() }))] : [] : [];
            localTeams = [...updatedTeams];
          }
          else {
            combinedSites = location.type === ComponentTypes.SharePoint ? sites ? [...sites.map((site, index) => ({ ...site, key: "s" + index, randomId: generateRandomString() }))] : [] : [];
          }

          localTeams?.forEach((team, index) => {
            if (!combinedSites.some(site => site.id === team.siteId)) {
              combinedSites.push({
                id: team.id,
                siteId: team.siteId,
                name: team.displayName,
                webUrl: team.webUrl,
                isSubsite: false,
                key: "t" + index,
                teamDriveId: team.driveId,
                teamGroupId: team.id,
                randomId: generateRandomString(),
              });
            }
          });

          for (const site of combinedSites) {
            const team = localTeams?.find(x => (x.siteId === site.siteId || x.siteId === site.id));
            if (team) {
              site.id = team.id;
              site.siteId = team.siteId;
              site.isTeam = true;
              site.isSite = false;
              site.teamDriveId = team.driveId;
              site.teamGroupId = team.id;
              site.isSharedTeam = team.isSharedTeam;
            }
            site.canExpand = true;
            site.expanded = false;
            site.parentId = location.id;
            site.treeType = DirectoryTreeType.site;
            site.level = 2;
            site.isLoading = false;
            site.loaded = false;
            site.isSelected = false;

            if (preExpandTeamId && site.teamGroupId && site.teamGroupId === preExpandTeamId) {
              try {
                const siteChildren: SiteChildren = await loadSiteChildren(site);

                site.channels = siteChildren.channels;
                site.documents = siteChildren.documents;
                site.subSites = siteChildren.subSites;

                location.expanded = true;
                site.expanded = true;
                site.loaded = true;
              } catch (error) {
                logger(error, "Locations.tsx (onLocationChevronClicked - PreExpandTeamId)");
              }
            }
          }

          setLocations(prevLocations => {
            return prevLocations.map(prevLocation => {
              if (prevLocation.id === location.id) {
                const sites = (isServerRefresh || isRefresh) ? [...combinedSites] : [...(prevLocation.sites || []), ...combinedSites];
                return {
                  ...prevLocation,
                  sites: SharePointSiteHelper.groupAndSortSites(sites),
                  expanded: (isServerRefresh || isRefresh) ? location.expanded : !location.expanded,
                  canExpand: sites?.length > 0,
                  isLoading: false,
                  loaded: true,
                  isServerRefreshed: isServerRefresh
                };
              } else {
                return prevLocation;
              }
            });
          });
        } catch (error) {
          logger(error, "Locations.tsx: onLocationChevronClicked");
          setLocationItem(location, undefined, false);
        }
      }
      else if ((!location.expanded && location.sites?.length > 0) || location.expanded) {
        setLocations(prevLocations => {
          return prevLocations.map(prevLocation => {
            if (prevLocation.id === location.id) {
              return {
                ...prevLocation,
                expanded: !location.expanded
              };
            } else {
              return prevLocation;
            }
          });
        });
      }
    }
  };

  const onLocationSitesChevronClicked = async (location: ISiteInfoLocation, isRefresh: boolean = false) => {
    // if (isRefresh|| (!location.expanded && (((location.isSite || location.isSubsite) && (!location.documents || location.documents?.length === 0)) || (location.isTeam && (!location.channels || location.channels?.length === 0))))) {
    if (isRefresh || (!location.expanded && !location.loaded)) {
      setLocationItem(location, undefined, true);
      try {
        const siteChildren: SiteChildren = await loadSiteChildren(location);
        setLocationsSiteSubsiteUpdate(location, siteChildren.subSites, siteChildren.documents, undefined, undefined, false, isRefresh, siteChildren.subSitesNextHref, siteChildren.channels);
      } catch (error) {
        logger(error, "Locations.tsx (onLocationSitesChevronClicked)");
        setLocationItem(location, undefined, false);
      }
    }
    else if ((!location.expanded && (location.documents?.length > 0 || location.channels?.length > 0) || location.subSites?.length > 0) || location.expanded) {
      setLocationsToggleExpanded(location);
    }
  }

  const loadSiteChildren = async (site: ISiteInfoLocation): Promise<SiteChildren> => {
    const accessToken = await authModule.getGraphAccessToken();
    let [subSitesResult, documentLibrariesResult, channelsResult, hubSitesResult] = await Promise.all([
      !site.isSharedTeam ? getSharePointSubsite(accessToken, site.isTeam ? site.siteId : site.id, allowedSiteCollections) : { data: [], nextPageLink: null },
      !site.isSharedTeam && (!hideDocumentLibrariesInTeams || !site.isTeam) ? getSharePointDocumentLibraries(accessToken, site.isTeam ? site.siteId : site.id, generalModule.isInConentMangerMode()) : [],
      site.isTeam ? getChannels(site.teamGroupId, site.teamDriveId) : [],
      site.isHub ? getHubSiteSites(accessToken, site.hubId, allowedSiteCollections) : []
    ]);

    const level = site.level;

    let subSites: ISiteInfoLocation[] = (subSitesResult?.data ?? [])
      .concat(hubSitesResult ?? [])
      .map(subSite => {
        return {
          ...subSite,
          name: subSite.displayName,
          isSubsite: !subSite.isHub,
          parentId: site.id,
          treeType: DirectoryTreeType.site,
          canExpand: true,
          expanded: false,
          level: level + 1,
          isLoading: false,
          randomId: generateRandomString()
        }
      });

    const documents: ISharepointDocumentLocation[] = documentLibrariesResult?.map(doc => {
      return {
        ...doc,
        parentId: site.id,
        treeType: DirectoryTreeType.document,
        level: level + 1,
        canExpand: true,
        expanded: false,
        isLoading: false,
        randomId: generateRandomString()
      }
    });

    const channels: ITeamChannelLocationDto[] = channelsResult?.map(channel => {
      return {
        ...channel,
        parentId: site.id,
        treeType: DirectoryTreeType.channel,
        isSelected: false,
        key: site.key,
        level: level + 1,
        randomId: generateRandomString(),
        canExpand: true,
        expanded: false,
        loaded: false
      }
    });

    return { channels, documents, subSites, subSitesNextHref: subSitesResult.nextPageLink };
  }

  const onLocationTessAccountChevronClicked = async (location: ITessAccountLocation, isRefresh: boolean = false) => {
    if (isRefresh || (!location.expanded && !location.loaded)) {
      setLocationItem(location, undefined, true);
      try {
        const accessToken = await authModule.getGraphAccessToken();
        // const [documentLibraries, projectFolders] = await Promise.all([
        //   getSharePointDocumentLibraries(accessToken, location.id),
        //   getTessAccountProjects(location.accountId)
        // ]);

        // const documents: ISharepointDocumentLocation[] = documentLibraries?.map(doc => {
        //   return {
        //     ...doc,
        //     parentId: location.id,
        //     treeType: DirectoryTreeType.document,
        //     level: location.level + 1,
        //     canExpand: true,
        //     expanded: false,
        //     isLoading: false,
        //     randomId: generateRandomString()
        //   }
        // });

        // const projectFolderLocations: ITessProjectFolderLocation[] = [];
        // if (projectFolders) {
        //   TessProjectStatuses.forEach(status => {
        //     let projects: ITessProject[] = projectFolders[status.key];
        //     if (Array.isArray(projects) && projects.length > 0) {
        //       const randomString: string = generateRandomString();
        //       projectFolderLocations.push({
        //         id: randomString,
        //         name: status.value,
        //         treeType: DirectoryTreeType.projectFolder,
        //         level: location.level + 1,
        //         canExpand: true,
        //         expanded: false,
        //         isLoading: false,
        //         randomId: randomString,
        //         projects
        //       });
        //     }
        //   });
        // }

        // setLocationsSiteSubsiteUpdate(location, undefined, documents, undefined, undefined, false, isRefresh, undefined, undefined, projectFolderLocations);

        const projectFolders = await getTessAccountProjects(location.accountId);

        const documentLibraries: ISharepointDocumentLocation[] = [];
        const projectAccountFolders: IFolderLocation[] = [];
        const projectFolderLocations: ITessProjectFolderLocation[] = [];
        if (projectFolders) {
          if (projectFolders.account?.dossierMetadata?.length > 0) {
            await Promise.all(projectFolders.account?.dossierMetadata
              .filter(dossier => dossier.driveId && !dossier.itemId)
              .map(async dossier => {
                const documentLibraryData = await getItemCustomSelect(accessToken, dossier.driveId, null, "id,name,webUrl,sharepointIds");
                if (documentLibraryData) {
                  documentLibraries.push({
                    id: documentLibraryData.id,
                    name: dossier.name,
                    webUrl: documentLibraryData.webUrl,
                    siteUrl: documentLibraryData.sharePointIds.siteUrl,
                    siteId: documentLibraryData.sharePointIds.siteId,
                    sharePointListId: documentLibraryData.sharePointIds.listId,
                    parentId: location.id,
                    treeType: DirectoryTreeType.document,
                    level: location.level + 1,
                    canExpand: true,
                    expanded: false,
                    isLoading: false,
                    randomId: generateRandomString()
                  });
                }
              }));

            await Promise.all(projectFolders.account?.dossierMetadata
              .filter(dossier => dossier.driveId && dossier.itemId)
              .map(async dossier => {
                const folderData = await getItemCustomSelect(accessToken, dossier.driveId, dossier.itemId, "id,name,folder,webDavUrl,sharepointIds");
                if (folderData) {
                  projectAccountFolders.push({
                    id: folderData.id,
                    name: dossier.name,
                    level: location.level + 1,
                    driveId: dossier.driveId,
                    sharePointUniqueId: folderData.sharepointIds.listItemUniqueId,
                    contentTypeId: SharePointFolderContentTypeIds.folder,
                    path: tryDecodeUriComponent(new URL(folderData.webDavUrl).pathname),
                    canExpand: folderData.folder?.childCount > 0,
                    expanded: false,
                    isLoading: false,
                    webUrl: folderData.sharepointIds.siteUrl,
                    sharePointListId: folderData.sharepointIds.listId,
                    treeType: DirectoryTreeType.folder,
                    randomId: generateRandomString(),
                    canRefresh: true
                  } as any);
                }
              }));
          }

          TessProjectStatuses.forEach(status => {
            let projects: ITessProject[] = projectFolders[status.key];
            if (Array.isArray(projects) && projects.length > 0) {
              const randomString: string = generateRandomString();
              projectFolderLocations.push({
                id: randomString,
                name: getStatusText(languageStrings, status.key),
                treeType: DirectoryTreeType.tessProjectStatusContainer,
                level: location.level + 1,
                canExpand: true,
                expanded: false,
                isLoading: false,
                randomId: randomString,
                projects: projects.map(project => ({ ...project, accountId: location.accountId }))
              });
            }
          });
        }

        setLocationsSiteSubsiteUpdate(location, undefined, documentLibraries, projectAccountFolders, undefined, false, isRefresh, undefined, undefined, projectFolderLocations);
      } catch (error) {
        logger(error, "Locations.tsx (onLocationTessAccountChevronClicked)");
        setLocationItem(location, undefined, false);
      }
    }
    else if (location.expanded || location.documents?.length > 0 || location.projectFolders?.length > 0) {
      setLocationsToggleExpanded(location);
    }
  };

  const onLocationTessProjectFolderChevronClicked = async (location: ITessProjectFolderLocation, isRefresh: boolean = false) => {
    if (isRefresh || (!location.expanded && !location.loaded)) {
      setLocationItem(location, undefined, true);
      try {
        // const projectSites = (await Promise.all(location.projects.map(async project => {
        //   let siteLocation: ISiteInfoLocation;
        //   if (Array.isArray(project.dossierMetadata) && project.dossierMetadata.length > 0) {
        //     const siteHit: IHit = await getSharePointSiteFromDriveId(project.dossierMetadata[0].driveId);
        //     if (siteHit) {
        //       const randomString: string = generateRandomString();
        //       const site: ISiteInfo = { ...mapSites(siteHit.resource), tessProjectId: project.id };
        //       siteLocation = {
        //         ...site,
        //         name: project.name,
        //         isSubsite: false,
        //         key: randomString,
        //         randomId: randomString,
        //         canExpand: true,
        //         expanded: false,
        //         treeType: DirectoryTreeType.site,
        //         level: location.level + 1,
        //         isLoading: false,
        //         loaded: false,
        //         isSelected: false
        //       };
        //     }
        //   }
        //   return siteLocation;
        // })))
        //   .filter(x => x);

        // setLocationsSiteSubsiteUpdate(location, projectSites, undefined, undefined, undefined, false, isRefresh, undefined);
        const projectSites = (await Promise.all(location.projects.map(async project => {
          let projectLocation: ITessProjectLocation;
          if (Array.isArray(project.dossierMetadata) && project.dossierMetadata.length > 0) {
            projectLocation = {
              ...project,
              tessProjectId: project.id,
              randomId: generateRandomString(),
              canExpand: true,
              expanded: false,
              treeType: DirectoryTreeType.tessProject,
              level: location.level + 1,
              isLoading: false,
              loaded: false,
              isSelected: false
            };
          }
          return projectLocation;
        })))
          .filter(x => x);

        setLocationsSiteSubsiteUpdate(location, undefined, undefined, undefined, undefined, false, isRefresh, undefined, undefined, undefined, projectSites);

      } catch (error) {
        logger(error, "Locations.tsx (onLocationTessProjectFolderChevronClicked)");
        setLocationItem(location, undefined, false);
      }
    }
    else if (location.expanded || (location.projects?.length > 0)) {
      setLocationsToggleExpanded(location);
    }
  };

  const onLocationTessProjectChevronClicked = async (location: ITessProjectLocation, isRefresh: boolean = false) => {
    if (isRefresh || (!location.expanded && !location.loaded)) {
      setLocationItem(location, undefined, true);
      try {
        const accessToken = await authModule.getGraphAccessToken();

        const documentLibraries: ISharepointDocumentLocation[] = [];
        const projectAccountFolders: IFolderLocation[] = [];

        if (location?.dossierMetadata?.length > 0) {
          await Promise.all(location.dossierMetadata
            .filter(dossier => dossier.driveId && !dossier.itemId)
            .map(async dossier => {
              const documentLibraryData = await getItemCustomSelect(accessToken, dossier.driveId, null, "id,name,webUrl,sharepointIds");
              if (documentLibraryData) {
                documentLibraries.push({
                  id: documentLibraryData.id,
                  name: dossier.name,
                  webUrl: documentLibraryData.webUrl,
                  siteUrl: documentLibraryData.sharePointIds.siteUrl,
                  siteId: documentLibraryData.sharePointIds.siteId,
                  sharePointListId: documentLibraryData.sharePointIds.listId,
                  parentId: location.id,
                  treeType: DirectoryTreeType.document,
                  level: location.level + 1,
                  canExpand: true,
                  expanded: false,
                  isLoading: false,
                  randomId: generateRandomString()
                });
              }
            }));

          await Promise.all(location.dossierMetadata
            .filter(dossier => dossier.driveId && dossier.itemId)
            .map(async dossier => {
              const folderData = await getItemCustomSelect(accessToken, dossier.driveId, dossier.itemId, "id,name,folder,webDavUrl,sharepointIds");
              if (folderData) {
                projectAccountFolders.push({
                  id: folderData.id,
                  name: dossier.name,
                  level: location.level + 1,
                  driveId: dossier.driveId,
                  sharePointUniqueId: folderData.sharepointIds.listItemUniqueId,
                  contentTypeId: SharePointFolderContentTypeIds.folder,
                  path: tryDecodeUriComponent(new URL(folderData.webDavUrl).pathname),
                  canExpand: folderData.folder?.childCount > 0,
                  expanded: false,
                  isLoading: false,
                  webUrl: folderData.sharepointIds.siteUrl,
                  sharePointListId: folderData.sharepointIds.listId,
                  treeType: DirectoryTreeType.folder,
                  randomId: generateRandomString(),
                  canRefresh: true
                } as any);
              }
            }));
        }

        setLocationsSiteSubsiteUpdate(location, undefined, documentLibraries, projectAccountFolders, undefined, false, isRefresh, undefined);
      } catch (error) {
        logger(error, "Locations.tsx (onLocationTessProjectChevronClicked)");
        setLocationItem(location, undefined, false);
      }
    }
    else if (location.expanded || location.documents?.length > 0 || location.folders?.length > 0) {
      setLocationsToggleExpanded(location);
    }
  };

  const setLocationsToggleExpanded = (location: any) => {
    setLocations(prevLocations => {
      const recursiveMap = (sites) => {
        return sites?.map(site => {
          let updatedSite = site;
          if (site.id === location.id && site.randomId === location.randomId) {
            return {
              ...site,
              expanded: !location.expanded,
              isLoading: false,
              isLoadingChannelInfo: false
            };
          }
          if (site.subSites) {
            updatedSite = {
              ...updatedSite,
              subSites: recursiveMap(site.subSites),
            };
          }
          if (site.documents) {
            updatedSite = {
              ...updatedSite,
              documents: recursiveMap(site.documents),
            };
          }
          if (site.channels) {
            updatedSite = {
              ...updatedSite,
              channels: recursiveMap(site.channels),
            };
          }
          if (site.folders) {
            updatedSite = {
              ...updatedSite,
              folders: recursiveMap(site.folders),
            };
          }
          if (site.accounts) {
            updatedSite = {
              ...updatedSite,
              accounts: recursiveMap(site.accounts),
            };
          }
          if (site.projectFolders) {
            updatedSite = {
              ...updatedSite,
              projectFolders: recursiveMap(site.projectFolders),
            };
          }
          if (site.projects) {
            updatedSite = {
              ...updatedSite,
              projects: recursiveMap(site.projects)
            };
          }

          return updatedSite;
        });
      }

      return prevLocations.map(prevLocation => {
        if (prevLocation.type === ComponentTypes.OneDrive && prevLocation.id == location.id) {
          return {
            ...prevLocation,
            expanded: !location.expanded,
          };
        }
        if (prevLocation.sites) {
          return {
            ...prevLocation,
            sites: recursiveMap(prevLocation.sites),
          };
        }
        if (prevLocation.accounts) {
          return {
            ...prevLocation,
            accounts: recursiveMap(prevLocation.accounts),
          };
        }
        if (prevLocation.projectFolders) {
          return {
            ...prevLocation,
            projectFolders: recursiveMap(prevLocation.projectFolders),
          };
        }
        if (prevLocation.folders) {
          return {
            ...prevLocation,
            folders: recursiveMap(prevLocation.folders),
          };
        }
        return prevLocation;
      });
    });
  };

  const setLocationsSiteSubsiteUpdate = (
    location: any,
    subsites: ISiteInfoLocation[],
    documents: ISharepointDocumentLocation[],
    folders: IFolderLocation[],
    foldersNextHref: string,
    isLoadmore: boolean = false,
    isRefresh: boolean = false,
    subSitesNextHref: string,
    channels?: ITeamChannelDto[],
    projectFolders?: ITessProjectFolderLocation[],
    projects?: ITessProjectLocation[]
  ) => {
    setLocations(prevLocations => {
      const recursiveFolderUpdate = (items) => {
        return items.map(item => {
          let updatedItem = item;
          if (item.id === location.id && item.randomId === location.randomId) {
            updatedItem = {
              ...item,
              folders: [...(folders ?? [])],
              foldersNextHref: foldersNextHref ? foldersNextHref : "",
              expanded: (isLoadmore || isRefresh) ? item.expanded : !item.expanded,
              canExpand: folders?.length > 0,
              isLoading: false,
              loaded: true,
            };
          }
          else if (item.folders) {
            updatedItem = {
              ...updatedItem,
              folders: recursiveFolderUpdate(item.folders),
            };
          }
          return updatedItem;
        });
      }

      const recursiveUpdate = (sites) => {
        return sites.map(site => {
          let updatedSite = site;
          if (site.id === location.id && site.randomId === location.randomId) {
            updatedSite = {
              ...site,
              folders: Array.isArray(folders) ? [...folders] : [],
              subSites: subsites,
              subSitesNextHref: subSitesNextHref ? subSitesNextHref : "",
              channels: channels,
              documents: Array.isArray(documents) ? (isRefresh || isLoadmore) ? [...documents] : [...(site.documents || []), ...documents] : [],
              projectFolders: projectFolders,
              projects,
              expanded: (isRefresh || isLoadmore) ? site.expanded : !site.expanded,
              isLoading: false,
              loaded: true,
            };

            return updatedSite;
          }
          if (site.subSites) {
            updatedSite = {
              ...updatedSite,
              subSites: recursiveUpdate(site.subSites),
            };
          }
          if (site.channels) {
            updatedSite = {
              ...updatedSite,
              channels: recursiveFolderUpdate(site.channels),
            };
          }
          if (site.documents) {
            updatedSite = {
              ...updatedSite,
              documents: recursiveFolderUpdate(site.documents),
            };
          }
          if (site.folders) {
            updatedSite = {
              ...updatedSite,
              folders: recursiveFolderUpdate(site.folders),
            };
          }
          if (site.accounts) {
            updatedSite = {
              ...site,
              accounts: recursiveUpdate(site.accounts),
            };
          }
          if (site.projectFolders) {
            updatedSite = {
              ...updatedSite,
              projectFolders: recursiveUpdate(site.projectFolders),
            };
          }
          if (site.projects) {
            updatedSite = {
              ...updatedSite,
              projects: recursiveUpdate(site.projects),
            };
          }
          return updatedSite;
        });
      }

      return prevLocations.map(prevLocation => {
        if (prevLocation.sites) {
          return {
            ...prevLocation,
            sites: recursiveUpdate(prevLocation.sites),
          };
        }
        if (prevLocation.accounts) {
          return {
            ...prevLocation,
            accounts: recursiveUpdate(prevLocation.accounts),
          };
        }
        if (prevLocation.projectFolders) {
          return {
            ...prevLocation,
            projectFolders: recursiveUpdate(prevLocation.projectFolders),
          };
        }
        if (prevLocation.projects) {
          return {
            ...prevLocation,
            projects: recursiveUpdate(prevLocation.projects),
          };
        }
        if (prevLocation.folders && prevLocation.id === location.id && prevLocation.randomId === location.randomId && isLoadmore) {
          return {
            ...prevLocation,
            folders,
            foldersNextHref,
            isLoading: false,
          };
        }
        if (prevLocation.folders) {
          return {
            ...prevLocation,
            folders: recursiveFolderUpdate(prevLocation.folders),
          };
        }
        return prevLocation;
      });
    });
  };

  const setLocationItem = (location: any, isSelected?: boolean, isLoading?: boolean, isLoadingChannelInfo?: boolean) => {
    setLocations((prevLocations) => {
      if (isSelected !== undefined) {
        selectedItem.current = { id: location.id, randomId: location.randomId };
      }
      const recursiveMap = (sites) => {
        return sites.map((site: any) => {
          let updatedSite = site;
          let isCurrentItemSelected = selectedItem.current && site.id === selectedItem.current.id && site.randomId === selectedItem.current.randomId;

          if (site.id === location.id && site.randomId === location.randomId) {
            updatedSite = {
              ...site,
              isLoading: isLoading !== undefined ? isLoading : site.isLoading,
              isSelected: isSelected !== undefined ? isSelected : site.isSelected,
              isLoadingChannelInfo: isLoadingChannelInfo !== undefined ? isLoadingChannelInfo : site.isLoadingChannelInfo,
            };
          }
          else if (isCurrentItemSelected) {
            updatedSite = {
              ...site,
              isSelected: isSelected !== undefined ? isSelected : site.isSelected
            };
          }
          else {
            updatedSite = {
              ...site,
              isSelected: false
            };
          }
          if (site.subSites) {
            updatedSite = {
              ...updatedSite,
              subSites: recursiveMap(site.subSites),
            };
          }
          if (site.documents) {
            updatedSite = {
              ...updatedSite,
              documents: recursiveMap(site.documents),
            };
          }
          if (site.channels) {
            updatedSite = {
              ...updatedSite,
              channels: recursiveMap(site.channels),
            };
          }
          if (site.folders) {
            updatedSite = {
              ...updatedSite,
              folders: recursiveMap(site.folders),
            };
          }
          if (site.accounts) {
            updatedSite = {
              ...updatedSite,
              accounts: recursiveMap(site.accounts),
            };
          }
          if (site.projectFolders) {
            updatedSite = {
              ...updatedSite,
              projectFolders: recursiveMap(site.projectFolders),
            };
          }
          if (site.projects) {
            updatedSite = {
              ...updatedSite,
              projects: recursiveMap(site.projects),
            };
          }
          return updatedSite;
        });
      };

      return prevLocations.map((prevLocation) => {
        try {
          if (
            (prevLocation.type === ComponentTypes.SharePoint
              || prevLocation.type === ComponentTypes.Teams
              || prevLocation.type === ComponentTypes.OneDrive
              || prevLocation.type === ComponentTypes.Tess)
            && prevLocation.id == location.id
          ) {
            return {
              ...prevLocation,
              isLoading: isLoading !== undefined ? isLoading : prevLocation.isLoading
            };
          }
          if (prevLocation.sites) {
            return {
              ...prevLocation,
              sites: recursiveMap(prevLocation.sites),
            };
          }
          if (prevLocation.folders) {
            return {
              ...prevLocation,
              folders: recursiveMap(prevLocation.folders),
            };
          }
          if (prevLocation.accounts) {
            return {
              ...prevLocation,
              accounts: recursiveMap(prevLocation.accounts),
            };
          }
          if (prevLocation.projectFolders) {
            return {
              ...prevLocation,
              projectFolders: recursiveMap(prevLocation.projectFolders),
            };
          }
          if (prevLocation.projects) {
            return {
              ...prevLocation,
              projects: recursiveMap(prevLocation.projects),
            };
          }
          return prevLocation;
        } catch (error) {
          return prevLocation;
        }
      });
    });
  };

  const onFolderSaveClicked = React.useCallback(async (item: any, e: any) => {
    e.preventDefault();
    e.stopPropagation();
    e.persist();

    setContextAwareLoading(true);

    try {
      const newWorkingDirectories = findWorkingDirectories(locations, item);
      const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
      if (item.isOneDrive) {
        treeStructureModule.setIsFolderInOneDrive(true);
        const currentDir = directories[directories.length - 1];

        const itemToSave = {
          id: currentDir.id,
          parentId: currentDir.parentId,
          type: ComponentTypes.OneDriveSubFolder,
          fileTitle: currentDir.fileTitle,
          directory: currentDir.directory,
          DocumentLibrary: "",
          displayName: currentDir.displayName,
          webUrl: currentDir.webUrl,
        };

        savingLocationStructureModule.addSavingLocationStructure(itemToSave);

        setSavingLocation(
          {
            display: itemToSave.displayName,
            webUrl: itemToSave.webUrl,
            directory: itemToSave.directory,
            isOneDriveFolder: true
          },
          true
        );

        if (isInContentManagerMode) {
          generalModule.setOpenPanelUploadPanel(true);
          setWorkingDirectories(directories);
        }
        else if (mode === ModeEnum.office) {
          if (directories.length > 0) {
            directories[directories.length - 1].isSaveLocationStructureSet = true;
            directories[directories.length - 1].type = ComponentTypes.Saving;
          }

          addWorkingDirectory(directories[directories.length - 1]);
        } else {
          // saveToOneDrive(item.name, itemToSave, currentDir.directory); // since redux wont update its state after all the operations are done and I need the data now
          if (directories.length > 0) {
            const savingDirectory = {
              ...directories[directories.length - 1],
              isSaveLocationStructureSet: true,
              displayName: languageStrings.Properties,
              type: ComponentTypes.Saving
            }

            const newLocations = [
              ...directories,
              savingDirectory,
            ];

            setWorkingDirectories(newLocations);
          }
        }
      } else {
        if (isInContentManagerMode) {
          generalModule.setOpenPanelUploadPanel(true);
          setWorkingDirectories(directories);
        } else {
          savingLocationStructureModule.setSavingLocationStructure(directories);

          const savingDirectory = {
            ...directories[directories.length - 1],
            isSaveLocationStructureSet: true,
            displayName: languageStrings.Properties,
            type: ComponentTypes.Saving
          }

          const newLocations = [
            ...directories,
            savingDirectory,
          ];

          setWorkingDirectories(newLocations);
        }
      }
    } catch (error) {
      logger(error, "Locations.tsx (onFolderSaveClicked)");
    }

    setContextAwareLoading(false);
  }, [locations, user]);

  const dismissFileOptionPanel = React.useCallback(() => {
    setFileOptionPanelInfo(initialFileOptionPanelInfoSetting);
  }, []);

  const dismissFolderOptionPanel = React.useCallback(() => {
    setFolderOptionPanelInfo(initialFolderOptionPanelInfoSetting);
  }, []);

  const openFileOptions = (storeItem: IStoreItem, isRecentItem: boolean = false) => {
    const options = {
      driveId: storeItem.driveId,
      fileType: storeItem.extension,
      name: storeItem.name,
      lastModifiedDateTime: storeItem.lastModifiedDateTime,
      isOpen: true,
      itemId: storeItem.itemId,
      folderId: storeItem.folderId,
      isRecentItem: isRecentItem,
      filePath: storeItem.filePath,
      modifiedBy: storeItem.modifiedBy,
      isFromHomePage: true,
      isFromPinnedItems: !isRecentItem,
      cannotbeRemoved: storeItem?.cannotBeRemoved
    };

    setFileOptionPanelInfo(options);
  };

  const openFolderOptions = (storeItem: IStoreItem, isRecentItem: boolean = false, isSuggestedList: boolean = false) => {
    const isSharedTeamsChannel: boolean = Array.isArray(storeItem.locations)
      && storeItem.locations.length > 0
      && storeItem.locations[storeItem.locations.length - 1].isSharedTeamsChannel;

    const folderType: FolderTypeEnum = FolderTypeIconQuery.getFolderType(storeItem.folderTypeIcon);

    const options: IFolderPanelInfo = {
      isOpen: true,
      folder: {
        driveId: storeItem.driveId,
        id: !isSharedTeamsChannel ? storeItem.itemId : null,
        name: storeItem.name,
        sharePointListId: storeItem.sharePointListId,
        sharePointUniqueId: !isSharedTeamsChannel ? storeItem.sharePointUniqueId : null,
        isSharedTeam: storeItem.isSharedTeam,
        isList: storeItem.isList || folderType === FolderTypeEnum.sharepointList
      },
      locations: storeItem.locations,
      siteId: storeItem.siteId,
      webUrl: storeItem.webUrl,
      saveToOneDrive: saveToOneDrive,
      folderType,
      isARecentItem: isSuggestedList ? false : isRecentItem,
      isFromHomePage: true,
      isFromPinnedItems: isSuggestedList ? false : !isRecentItem,
      isTeamsSiteInsideSharepoint: storeItem.isTeamsSiteInsideSharepoint,
      isFromSuggestedItems: isSuggestedList,
      tessAccountId: storeItem.tessAccountId,
      tessProjectId: storeItem.tessProjectId
    }
    setFolderOptionPanelInfo(options);
  };

  const licenseDialog = (
    <Dialog hidden={isLicenseDialogHidden} onDismiss={hideLicenseDialog} dialogContentProps={licenseMessageContent}>
      <DialogFooter>
        <PrimaryButton autoFocus onClick={hideLicenseDialog} text="Ok" />
      </DialogFooter>
    </Dialog>
  );

  const folderDialogContentProps = {
    type: DialogType.largeHeader,
    title: languageStrings.FolderDeleted,
    closeButtonAriaLabel: "Close",
    subText: languageStrings.FolderRecentlyDeleted
  };

  const folderDeletedDialog = (
    <Dialog
      hidden={!folderDeleteDialog.showFolderDeleteDialog}
      onDismiss={() => setShowFolderDeleteDialog(false)}
      dialogContentProps={folderDialogContentProps}
    >
      <DialogFooter>
        <PrimaryButton
          autoFocus
          onClick={() => {
            setShowFolderDeleteDialog(false);
          }}
          text="Ok"
        />
      </DialogFooter>
    </Dialog>
  );

  const fileDialogContentProps = {
    type: DialogType.largeHeader,
    title: languageStrings.FileDeleted,
    closeButtonAriaLabel: "Close",
    subText: languageStrings.FileRecentlyDeleted
  };

  const fileDeletedDialog = (
    <Dialog
      hidden={isFileDeletionDialogHidden}
      onDismiss={hideFileDeleteDialog}
      dialogContentProps={fileDialogContentProps}
    >
      <DialogFooter>
        <PrimaryButton autoFocus onClick={hideFileDeleteDialog} text="Ok" />
      </DialogFooter>
    </Dialog>
  );

  return (
    <>
      {loading && <Loader hide={hide} />}
      <div className={hide ? "none" : undefined}>
        {(!isInContentManagerMode && mode !== ModeEnum.office) ?
          <SuggestedItems
            mode={modeEnum}
            openFileOptions={openFileOptions}
            openFolderOptions={openFolderOptions}
            showLicenseDialog={showLicenseDialog}
            saveToOneDrive={saveToOneDrive}
            setLicenseMessageContent={setLicenseMessageContent}
          /> : null}
        {(!isSideMenuCollapsed && userSettings.showPinned) ?
          <PinnedItems
            mode={modeEnum}
            openFileOptions={openFileOptions}
            openFolderOptions={openFolderOptions}
            showLicenseDialog={showLicenseDialog}
            saveToOneDrive={saveToOneDrive}
            setLicenseMessageContent={setLicenseMessageContent}
          /> : null}
        {(!isSideMenuCollapsed && userSettings.showRecent) ?
          <RecentItems
            mode={modeEnum}
            openFileOptions={openFileOptions}
            openFolderOptions={openFolderOptions}
            showLicenseDialog={showLicenseDialog}
            saveToOneDrive={saveToOneDrive}
            setLicenseMessageContent={setLicenseMessageContent}
          /> : null}
        {(!isSideMenuCollapsed && userSettings.showShared) &&
          <SharedItems
            mode={modeEnum}
            openFileOptions={openFileOptions}
            openFolderOptions={openFolderOptions}
            showLicenseDialog={showLicenseDialog}
            saveToOneDrive={saveToOneDrive}
            setLicenseMessageContent={setLicenseMessageContent}
          />}
        {!isSideMenuCollapsed && <ExpanderWithSubtitle
          iconName="Cloud"
          items={locationItems}
          title={languageStrings.Locations}
          expanderNameToToggle={expanderConstants.home.locations}
          fixedHeight={locationHeight}
          allowScroll
        />}
        {isSideMenuCollapsed && locationItemsShort}
        {(!isSideMenuCollapsed && (userSettings.enableApprovals || (nintexClientId && nintexClientSecret))) && <MyApprovals requestFlowResourceToken={requestFlowResourceToken} />}
        {fileOptionPanelInfo?.isOpen &&
          <FileOptionPanel
            info={fileOptionPanelInfo}
            dismissPanel={dismissFileOptionPanel}
            showFileDeletedDialog={showFileDeleteDialog}
          />}
        {folderOptionPanelInfo?.isOpen &&
          <FolderOptionPanel
            info={folderOptionPanelInfo}
            dismissPanel={dismissFolderOptionPanel}
          />}
        {licenseDialog}
        {fileDeletedDialog}
        {folderDeletedDialog}
      </div>
    </>
  );
};

export default React.memo(connector(Location));
